import { type Theme } from "@mui/material";

import { type MuiThemeComponentOverride } from "./types";

export function getMuiMenu(_theme: Theme): MuiThemeComponentOverride<"MuiMenu"> {
  return {
    MuiMenu: {
      styleOverrides: {
        list: { padding: "0.5rem" },
        paper: { margin: "0.25rem 0" },
      },
    },
  };
}
